<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeLotPaiement.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeLotPaiement.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto"
      :class="[
      {'hauteur-brief-filtre': errors.length === 0},
    {'hauteur-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <qd-notification type="is-primary" v-if="lots.length > 0"
                          class="is-marginless pd-6px"
                          @close="deleteIds()">
            {{ $t('listeLotPaiement.filtre.codeLot', { code: getCodeLots }) }}
          </qd-notification>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.datesRemise"
            :label="$t('listeLotPaiement.filtre.date')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeLotPaiement.filtre.etat')"
                      :items="constantes.LIST_REMISE_ETAT"
                      v-model="remiseBancaireEtatSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeLotPaiement.filtre.exporteeEnCompta')">
            <b-select v-model="critereRecherche.exporteeEnCompta" expanded>
              <option :value=null></option>
              <option :value=true>
                {{ $t('listeLotPaiement.filtre.exporteeEnComptaAnswer.yes') }}
              </option>
              <option :value=false>
                {{ $t('listeLotPaiement.filtre.exporteeEnComptaAnswer.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeLotPaiement.filtre.modeReglement')">
            <qd-taginput v-if="modeReglementTags"
                        v-model="modeReglementSelected"
                        :data="modeReglementTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredModeReglementTags"
                        @input="getModeReglementTag">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeLotPaiement.filtre.banque')">
            <qd-taginput
              v-if="domBancaireTags"
              v-model="domBancaireSelected"
              :data="domBancaireTags"
              type="is-primary"
              icon="magnify"
              autocomplete
              open-on-focus
              field="libelle"
              @typing="getFilteredDomBancaireTags"
              @input="getDomBancaireTag">
              <template slot-scope="props">
                {{ `${props.option.libelle} - ${props.option.libelleBanque}` }}
              </template>
            </qd-taginput>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeLotPaiement.filtre.actions.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeLotPaiement.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRechercheLotPaiement from '@/services/remiseBancaire/genererCritereRechercheLotPaiement';
import { SET_CRITERE_LOT_PAIEMENT } from '@/store/modules/remiseBancaire-mutation-type';
import { LIST_REMISE_ETAT } from '@/configuration/remiseBancaire/remiseBancaireConf';
import { get } from '@/api/remiseBancaire';
import messageErreur from '@/services/general/messageErreur';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import genererCritereRechercheLotPaiementRecette from '@/services/gabed/lotDePaiementRecette/genererCritereRechercheLotPaiementRecette';
import { MODULE_TLPE } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    nameStore: {
      type: String,
      required: false,
      default: 'remiseBancaire',
    },
    moduleDcf: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      errors: [],
      critereRecherche: null,
      constantes: {
        LIST_REMISE_ETAT,
      },
      remiseBancaireEtatSelected: [],
      lots: [],
      listeModeReglementBase: [],
      modeReglementSelected: [],
      modeReglementTags: null,
      listeDomBancaireBase: [],
      domBancaireSelected: [],
      domBancaireTags: null,
    };
  },
  components: {
    libelleTagInput,
    inputPeriode,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    critereRechercheLotPaiement: {
      get() {
        return this.$store.getters[`${this.nameStore}/critereRechercheLotPaiement`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/SET_CRITERE_LOT_PAIEMENT`, value);
      },
    },
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
    domBancaire() {
      return this.parametre(PARAMETRES_KEYS.domiciliationBancaire);
    },
    getCodeLots() {
      return this.lots.map(lot => formatCodeRemiseBancaire(lot.num, lot.nom)).join(', ');
    },
  },
  methods: {
    setCritereRechercheLotPaiement(critere) {
      return this.$store.commit(`${this.nameStore}/${SET_CRITERE_LOT_PAIEMENT}`, critere);
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    deleteIds() {
      this.lots = [];
      this.critereRecherche.id = [];
    },
    viderCritere() {
      this.remiseBancaireEtatSelected = [];
      this.modeReglementSelected = [];
      this.domBancaireSelected = [];
      this.getModeReglementTag();
      this.getDomBancaireTag();
      this.lots = [];
      this.critereRecherche = this.moduleDcf === MODULE_TLPE
        ? genererCritereRechercheLotPaiementRecette() : genererCritereRechercheLotPaiement();
    },
    appliquerCritere() {
      this.errors = [];
      if (this.critereRecherche.datesRemise.dateFin
        && this.critereRecherche.datesRemise.dateDebut
        > this.critereRecherche.datesRemise.dateFin) {
        this.errors.push({
          message: 'validation.dateDebutGreaterDateFin',
        });
      }
      if (this.errors.length > 0) return;
      this.critereRecherche.etat = this.remiseBancaireEtatSelected.map((el) => { return el.code; });
      this.critereRecherche.modesReglementsIds = this.modeReglementSelected.map((modeReglement) => {
        return modeReglement.id;
      });
      this.critereRecherche.domiciliationBancaireIds = this.domBancaireSelected
        .map((domBancaire) => {
          return domBancaire.id;
        });
      this.setCritereRechercheLotPaiement(this.critereRecherche);
      this.$emit('recherche');
    },
    getModeReglementTag() {
      this.modeReglementTags = this.listeModeReglementBase.filter((modeReglement) => {
        return !this.modeReglementSelected.map(a => a.id).includes(modeReglement.id);
      });
    },
    getFilteredModeReglementTags(text) {
      this.getModeReglementTag();
      this.modeReglementTags = this.modeReglementTags.filter((modeReglement) => {
        return modeReglement.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getDomBancaireTag() {
      this.domBancaireTags = this.listeDomBancaireBase.filter((domBancaire) => {
        return !this.domBancaireSelected.map(a => a.id).includes(domBancaire.id);
      });
    },
    getFilteredDomBancaireTags(text) {
      this.getDomBancaireTag();
      this.domBancaireTags = this.domBancaireTags.filter((domBancaire) => {
        return domBancaire.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.critereRechercheLotPaiement);
        await this.loadParametres([
          PARAMETRES_KEYS.modeReglement, PARAMETRES_KEYS.domiciliationBancaire,
        ]);
        if (this.critereRecherche.etat.length > 0) {
          this.remiseBancaireEtatSelected = this.constantes.LIST_REMISE_ETAT.filter((c) => {
            return this.critereRecherche.etat.includes(c.code);
          });
        }
        if (this.critereRecherche.id) {
          const promiseLot = [];
          this.critereRecherche.id.forEach((lotId) => {
            promiseLot.push(get(lotId));
          });
          this.lots = (await Promise.all(promiseLot)).map(rslt => rslt.data.result);
        }
        this.listeModeReglementBase = this.modesReglement;
        if (this.critereRecherche.modesReglementsIds.length > 0) {
          this.modeReglementSelected = this.listeModeReglementBase.filter((modeReglemnt) => {
            return this.critereRecherche.modesReglementsIds.includes(modeReglemnt.id);
          });
        }
        this.getModeReglementTag();

        this.listeDomBancaireBase = this.domBancaire;
        if (this.critereRecherche.domiciliationBancaireIds.length > 0) {
          this.domBancaireSelected = this.listeDomBancaireBase.filter((domBancaire) => {
            return this.critereRecherche.domiciliationBancaireIds.includes(domBancaire.id);
          });
        }
        this.getDomBancaireTag();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
